var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2513 17.4667C6.2513 18.8663 7.42627 20 8.87694 20C10.3276 20 11.5026 18.8663 11.5026 17.4667",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16164 4.79999C6.17908 4.00833 7.46564 3.53333 8.87692 3.53333C12.1393 3.53333 14.7846 6.08566 14.7846 9.23333V12.267C14.7846 13.141 15.2375 13.958 15.9924 14.4457C16.465 14.7497 16.7538 15.269 16.7538 15.82C16.7538 16.732 15.9858 17.473 15.0406 17.473H2.71323C1.768 17.473 1 16.732 1 15.82C1 15.269 1.28882 14.756 1.76144 14.4457C2.51631 13.958 2.96923 13.141 2.96923 12.267V9.23333C2.96923 8.32133 3.19241 7.45999 3.58626 6.69999",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90755 3.86267V2.9C6.90755 1.84867 7.78714 1 8.87678 1C9.4216 1 9.91391 1.21533 10.2684 1.55733C10.6228 1.89933 10.846 2.37433 10.846 2.9V3.86267",
    stroke: "#6856DB",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/NotificationsIcon.4dfb9c4874c9051c327025f1b7ccab5a.svg";
export { ForwardRef as ReactComponent };